import { useQuery } from '@tanstack/react-query';
import { IUserDetails } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetUserDetails = (id: string) =>
  useQuery({
    queryKey: ["get_user_details", id],
    queryFn: async (): Promise<IUserDetails> => {
      const res = await apiClient.get(ENDPOINTS.USERS.GET_USER_DETAILS(id));
      return res.data;
    },
    enabled: !!id,
  });



